// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  instagram_token: 'INSTAGRAM_TOKEN',
  stripe_token: 'STRIPE_PUBLISHABLE_KEY',
  paypal_token: 'PAYPAL_CLIENT_ID',
  FirebaseConfig: {
    apiKey: "AIzaSyA_VrDpJ_2-pJe4owh9oyMW2INHPVuyE9k",
    authDomain: "myfoodgenieweb.firebaseapp.com",
    projectId: "myfoodgenieweb",
    storageBucket: "myfoodgenieweb.appspot.com",
    messagingSenderId: "440855254275",
    appId: "1:440855254275:web:7a8384ce5f35df20bc4536",
    measurementId: "G-HB1HCWVBC7",
    messagingSWScope:
      'https://myfoodgenie.com/firebase-messaging-sw.js',
  },
  pushkeys: {
    publicKey: "BMrKhtrhS5jQWS-LVRzV8DPZzEN5yDWTXyYyhvN0bl5vvUOi5NabJXHHtdH6e9sqnMVCUszKKgvQ3LgvCaTJQR0",
    privateKey: "tk1y0l_D--jKF8wJ4UQGZzVWK23rIEDKGmeXflQyZdg"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
